import router from '@/router/index.js'
import store from '@/store/index.js'

import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
NProgress.configure({ showSpinner: false })

// 方法一：加载组件
router.loadComponent = (view) => {
    if (view.substring(0, 1) == "/") {
        view = view.substring(1);
    }
    return () => import(`@/views/${view}`)
}

// 方法二：路由初始化
router.initRouter = (menuList) => {
    var routerConfig = {
        path: '', name: 'layout', component: () => import('@/layout/layout.vue'),
        children: []
    }
    for (var menu of menuList) {
        if (menu.template == null || menu.template == "") {
            continue
        }
        else {
            routerConfig.children.push(
                {
                    path: menu.route,
                    component: router.loadComponent(menu.template)
                }
            )
        }
    }
    router.addRoute(routerConfig)
    router.addRoute({ path: '*', redirect: '/404' })
}

// 路由白名单
let whiteList = ['/', '/admin/login', '/404']

// 路由前置守卫
router.beforeEach((to, from, next) => {
    NProgress.start()
    if (to.path.indexOf('/exam/') >= 0) {
        document.title = '在线问答调研平台'
        next()
    }
    else if (whiteList.indexOf(to.path) >= 0) {
        document.title = '欢迎光临UMS平台'
        next()
    }
    else {
        document.title = 'UMS综合管理平台'
        let adminAccessToken = store.state.adminUser.accessToken
        if (adminAccessToken == null || adminAccessToken == "") {
            next("/404")
        }
        else {
            // 路由重定向
            if (to.path == "/admin/login") { next("/admin/index") }

            // 菜单权限过滤
            let adminRouter = store.getters.adminRouter
            if (adminRouter != null && adminRouter.length > 0) {
                next()
            }
            else {
                store.dispatch('adminMenus', {}).then(() => {
                    let accessRouter = store.getters.adminRouter
                    let { adminOrganizationId, checkOrganizationIds } = store.getters.adminPower
                    // && adminOrganizationId != null
                    if (accessRouter != null && accessRouter.length > 0) {
                        router.initRouter(accessRouter)
                        next({ ...to, replace: true })
                    }
                    else {
                        next("/404")
                    }
                })
            }
        }
    }
})

// 路由后置守卫
router.afterEach((to, from) => {
    NProgress.done()
})